import { AlertTriangle, Package, ArrowRight } from 'lucide-react';
import type { Consumable } from '@yawi/types';
import { useI18n } from '@/shared/i18n';

interface LowStockAlertProps {
  items: Consumable[];
  onItemClick?: (item: Consumable) => void;
  onViewAll?: () => void;
}

export const LowStockAlert = ({ items, onItemClick, onViewAll }: LowStockAlertProps) => {
  const { t } = useI18n();

  if (items.length === 0) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-xl p-4">
      <div className="flex items-center gap-2 mb-3">
        <AlertTriangle className="w-5 h-5 text-red-600" />
        <h3 className="font-semibold text-red-800">
          {t('inventory.lowStockWarning')} ({items.length})
        </h3>
      </div>

      <div className="space-y-2">
        {items.slice(0, 5).map((item) => (
          <div
            key={item.id}
            onClick={() => onItemClick?.(item)}
            className={`flex items-center justify-between p-2 bg-white rounded-lg ${
              onItemClick ? 'cursor-pointer hover:bg-red-100' : ''
            } transition-colors`}
          >
            <div className="flex items-center gap-2">
              <Package className="w-4 h-4 text-red-500" />
              <span className="text-sm font-medium text-slate-800">{item.name}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm text-red-600 font-bold">{item.currentStock}</span>
              <span className="text-xs text-slate-500">/ min: {item.minimumStock}</span>
            </div>
          </div>
        ))}
      </div>

      {items.length > 5 && onViewAll && (
        <button
          onClick={onViewAll}
          className="flex items-center gap-1 mt-3 text-sm text-red-700 hover:text-red-800 font-medium"
        >
          {t('common.viewAll')} ({items.length - 5} {t('common.more')})
          <ArrowRight className="w-4 h-4" />
        </button>
      )}
    </div>
  );
};
